var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMediaColored = function SvgMediaColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#6161FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#clip0_878_1292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 9.286A4.286 4.286 0 1 0 5 .714a4.286 4.286 0 0 0 0 8.572M15 9.286a2.857 2.857 0 1 0 0-5.714 2.857 2.857 0 0 0 0 5.714M14.286 12.857H6.429c-.79 0-1.429.64-1.429 1.429v3.571c0 .79.64 1.429 1.429 1.429h7.857c.789 0 1.428-.64 1.428-1.429v-3.571c0-.79-.64-1.429-1.428-1.429M19.286 14.286v3.571"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_878_1292"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgMediaColored;